import { ErrorCode, ResponceDataType} from "../../../ErrorCode"
export type MeasureLogDataType = {
  ///計測時刻
  /// MEASURE_LOG MSR_DATE
  MSR_DATE: Date;

  ///IMSI No.
  /// IOT_SET IMSI_NO
  IMSI_NO: string;

  ///PLCNo
  /// MEASURE_LOG PLC_NO
  PLC_NO: number;
  ///カード No.。
  /// MEASURE_LOG AI_CARD
  AI_CARD: number;
  ///CHNo.
  /// MEASURE_LOG AI_CH
  AI_CH: number;
  ///収集時間 (秒)
  /// MEASURE_LOG COL_TIME
  COL_TIME: number;
  ///ロギング開始日時
  /// MEASURE_LOG LOG_START
  LOG_START: string;
  ///状態
  /// MEASURE_LOG STATUS
  STATUS: string;
  ///自動 / 手動
  /// MEASURE_LOG MANUAL
  MANUAL: number;
  ///機器番号
  /// NAME_DEV_SET DEV_NO
  DEV_NO: string;
  ///機器名称
  /// NAME_DEV_SET DEV_NAME
  DEV_NAME: string;
  ///項目名称
  /// NAME_ITEM_SET ITM_NAME
  ITM_NAME: string;
  ///ロギング周期
  /// LOG_INT_SET DSP_STR
  DSP_STR: string;
}

export type ImageFileType = {
  FilePath: string;
  SearchFileName: string;
  ResponceData: ResponceDataType;
  Base64ImageData: string;
}


/**
 * 計測ログ情報取得(PLC版)
 * @returns
 */
export const GetMeasureModel = () : Promise<MeasureLogDataType[]> => {
  return new Promise((resolve, reject) => {
    const url = "api/MeasureLog";
    fetch(url)
    .then((res) => res.json())
      .then((result: MeasureLogDataType[]) => {
        console.debug(['GetMeasureModel res', result]);
        if (MeasureModelValidate(result)) resolve(result);
        reject('Invalidate response');
    },
      (error) => {
        console.log(error);
        reject(error);
      }
  );
  });
};

/**
 * 計測ログ情報取得(IOT版)
 * @returns
 */
export const GetMeasureIoTBoxModel = () : Promise<MeasureLogDataType[]> => {
  return new Promise((resolve, reject) => {
    const url = "api/MeasureLog/IoT";
    fetch(url)
    .then((res) => res.json())
      .then((result: MeasureLogDataType[]) => {
        console.debug(['GetMeasureIoTBoxModel res', result]);
        if (MeasureModelValidate(result)) resolve(result);
        reject('Invalidate response');
    },
      (error) => {
        console.log(error);
        reject(error);
      }
  );
  });
};


const MeasureModelValidate = (data: MeasureLogDataType[]) => {
    if (data == undefined) return false;
    return true;
};
